import React, {Component} from 'react'
import {v1 as uuidv1} from 'uuid'

import style from './resultRating.module.scss'

class ResultRating extends Component {
   state = {
      starCount: [0, 1, 2, 3, 4],
   }

   render() {
      const {rating} = this.props
      const {starCount} = this.state
      return (
         <div className={style.starRating}>
            {starCount.map(star => (
               <span className={`${style.star} + ' ' + ${style.star__outlined}`} key={uuidv1()}></span>
            ))}
            <div className={style.starRating__colored} style={{width: `${rating * 10}%`}}>
               {starCount.map(star => (
                  <span className={`${style.star} + ' ' + ${style.star__colored}`} key={uuidv1()}></span>
               ))}
            </div>
         </div>
      )
   }
}

export default ResultRating